/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BackOfficePromotionCampaignCreateRequest,
  BackOfficePromotionCampaignUpdateRequest,
  ErrorResponse,
  PromotionCampaign,
  UpdatePromotionPrioritiesRequestInner,
} from '../models/index';
import {
    BackOfficePromotionCampaignCreateRequestFromJSON,
    BackOfficePromotionCampaignCreateRequestToJSON,
    BackOfficePromotionCampaignUpdateRequestFromJSON,
    BackOfficePromotionCampaignUpdateRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PromotionCampaignFromJSON,
    PromotionCampaignToJSON,
    UpdatePromotionPrioritiesRequestInnerFromJSON,
    UpdatePromotionPrioritiesRequestInnerToJSON,
} from '../models/index';

export interface CreatePromotionCampaignRequest {
    customerId: string;
    backOfficePromotionCampaignCreateRequest: BackOfficePromotionCampaignCreateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeletePromotionCampaignRequest {
    customerId: string;
    id: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPromotionCampaignsRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdatePromotionCampaignRequest {
    customerId: string;
    id: string;
    backOfficePromotionCampaignUpdateRequest: BackOfficePromotionCampaignUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdatePromotionPrioritiesRequest {
    customerId: string;
    updatePromotionPrioritiesRequestInner: Array<UpdatePromotionPrioritiesRequestInner>;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PromotionCampaignsApi extends runtime.BaseAPI {

    /**
     * Create a new promotion campaign
     */
    async createPromotionCampaignRaw(requestParameters: CreatePromotionCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionCampaign>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createPromotionCampaign().'
            );
        }

        if (requestParameters['backOfficePromotionCampaignCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'backOfficePromotionCampaignCreateRequest',
                'Required parameter "backOfficePromotionCampaignCreateRequest" was null or undefined when calling createPromotionCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:promotion-campaigns"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/promotion-campaigns`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BackOfficePromotionCampaignCreateRequestToJSON(requestParameters['backOfficePromotionCampaignCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionCampaignFromJSON(jsonValue));
    }

    /**
     * Create a new promotion campaign
     */
    async createPromotionCampaign(requestParameters: CreatePromotionCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionCampaign> {
        const response = await this.createPromotionCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a promotion campaign
     */
    async deletePromotionCampaignRaw(requestParameters: DeletePromotionCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deletePromotionCampaign().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePromotionCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:promotion-campaigns"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/promotion-campaigns/{id}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a promotion campaign
     */
    async deletePromotionCampaign(requestParameters: DeletePromotionCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePromotionCampaignRaw(requestParameters, initOverrides);
    }

    /**
     * Get all promotion campaigns (including past and future ones) For back-office admin UI
     */
    async getPromotionCampaignsRaw(requestParameters: GetPromotionCampaignsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PromotionCampaign>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPromotionCampaigns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:promotion-campaigns"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/promotion-campaigns`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PromotionCampaignFromJSON));
    }

    /**
     * Get all promotion campaigns (including past and future ones) For back-office admin UI
     */
    async getPromotionCampaigns(requestParameters: GetPromotionCampaignsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PromotionCampaign>> {
        const response = await this.getPromotionCampaignsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing promotion campaign
     */
    async updatePromotionCampaignRaw(requestParameters: UpdatePromotionCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionCampaign>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updatePromotionCampaign().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePromotionCampaign().'
            );
        }

        if (requestParameters['backOfficePromotionCampaignUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'backOfficePromotionCampaignUpdateRequest',
                'Required parameter "backOfficePromotionCampaignUpdateRequest" was null or undefined when calling updatePromotionCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:promotion-campaigns"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/promotion-campaigns/update/{id}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BackOfficePromotionCampaignUpdateRequestToJSON(requestParameters['backOfficePromotionCampaignUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionCampaignFromJSON(jsonValue));
    }

    /**
     * Update an existing promotion campaign
     */
    async updatePromotionCampaign(requestParameters: UpdatePromotionCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionCampaign> {
        const response = await this.updatePromotionCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update promotion campaign priorities Nullifies all ended campaigns and updates specified campaigns with new priorities
     */
    async updatePromotionPrioritiesRaw(requestParameters: UpdatePromotionPrioritiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PromotionCampaign>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updatePromotionPriorities().'
            );
        }

        if (requestParameters['updatePromotionPrioritiesRequestInner'] == null) {
            throw new runtime.RequiredError(
                'updatePromotionPrioritiesRequestInner',
                'Required parameter "updatePromotionPrioritiesRequestInner" was null or undefined when calling updatePromotionPriorities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:promotion-campaigns"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/promotion-campaigns/priorities`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updatePromotionPrioritiesRequestInner']!.map(UpdatePromotionPrioritiesRequestInnerToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PromotionCampaignFromJSON));
    }

    /**
     * Update promotion campaign priorities Nullifies all ended campaigns and updates specified campaigns with new priorities
     */
    async updatePromotionPriorities(requestParameters: UpdatePromotionPrioritiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PromotionCampaign>> {
        const response = await this.updatePromotionPrioritiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
